export default __webpack_public_path__ + "static/media/requiment-bg-image.0143f004.jpg";